import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../BitsStyles/Community.css';

const services = [
  {
    icon: 'bi-code-slash',
    accent: '#3B82F6',
    title: 'Web & Mobile Development',
    description: 'Bringing your ideas to life with innovative mobile apps, dynamic web applications, and stunning websites that drive growth and engagement.',
  },
  {
    icon: 'bi-receipt-cutoff',
    accent: '#06B6D4',
    title: 'Billing & Payment Solutions',
    description: 'Revolutionize your transactions with smart billing solutions and effortless payment systems ensuring accuracy, security, and seamless experiences.',
  },
];

const Community = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('cm-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    const els = sectionRef.current?.querySelectorAll('[data-cm-animate]') || [];
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="cm-section" ref={sectionRef}>
      <div className="cm-orb cm-orb1"></div>
      <div className="cm-orb cm-orb2"></div>

      <div className="cm-inner">
        {/* Left text */}
        <div className="cm-text" data-cm-animate>
          <div className="section-eyebrow-light">Kickstart Your Next Project</div>
          <h2 className="h-section cm-title">
            Partner with <span className="grad-text">Bellary Info Tech</span> Solutions
          </h2>
          <p className="body-lg cm-desc">
            Empowering businesses with smart software — transform your ideas into reality with our Web Apps, Websites, and Billing &amp; Payment Solutions.
          </p>

          <div className="cm-ctas">
            <Link
              to="https://www.google.com/maps/place/15%C2%B009'42.8%22N+76%C2%B056'18.5%22E/@15.1618988,76.9358962,17z/data=!3m1!4b1!4m4!3m3!8m2!3d15.1618988!4d76.9384711"
              target="_blank"
              rel="noopener noreferrer"
              className="cm-btn-primary"
            >
              <i className="bi bi-geo-alt-fill"></i>
              Reach Us
            </Link>
            <Link to="/contact-bits#contact-form" className="cm-btn-ghost">
              Get In Touch <i className="bi bi-arrow-right"></i>
            </Link>
          </div>

          <div className="cm-badge">
            <i className="bi bi-building"></i>
            Bellary Info Tech Solutions
          </div>
        </div>

        {/* Right cards */}
        <div className="cm-cards">
          {services.map((s, i) => (
            <div
              key={i}
              className="cm-card"
              data-cm-animate
              style={{ '--cm-accent': s.accent, animationDelay: `${i * 0.15}s` }}
            >
              <div className="cm-card-icon" style={{ background: `${s.accent}18`, color: s.accent }}>
                <i className={`bi ${s.icon}`}></i>
              </div>
              <div className="cm-card-body">
                <h3 className="cm-card-title">{s.title}</h3>
                <p className="cm-card-desc">{s.description}</p>
              </div>
              <div className="cm-card-bar" style={{ background: s.accent }}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Community;
